import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailRecruiteeLogoComponent } from '../../components/email-recruitee-logo/email-recruitee-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { EmailMailgunIfDirective } from '../../directives/email-mailgun-if.directive';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import type { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  selector: 'email-notification-evaluation-mention-template',
  styleUrls: ['../../global-styles.less', './notification-evaluation-mention.component.less'],
  templateUrl: './notification-evaluation-mention.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailRecruiteeLogoComponent,
    EmailTextComponent,
    EmailLinkComponent,
    EmailMailgunIfDirective,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  // eslint-disable-next-line @angular-eslint/use-component-view-encapsulation
  encapsulation: ViewEncapsulation.None,
})
export class NotificationEvaluationMentionTemplateComponent {
  @Input({ required: true }) public data: WrappedValue<NotificationEvaluationMentionTemplateData>;
}

// `subject` is also sent by the API but is used as the email subject line, not interpolated
// in the body, so it is intentionally omitted here. `avatar_url` is null when the author has
// only an initials avatar (`has_avatar` is false).
export type NotificationEvaluationMentionTemplateData = {
  title: string;
  body: string;
  footer_p1: string;
  footer_link: string;
  footer_link_text: string;
  has_avatar: boolean;
  initials: string;
  avatar_url: string | null;
};

export const NotificationEvaluationMentionTemplateMocks: NotificationEvaluationMentionTemplateData[] =
  [
    {
      title: 'Alex Morgan mentioned you in an evaluation for Jamie Lee',
      body: 'You were mentioned in an evaluation.',
      footer_p1: 'Replies to this email are not monitored.',
      footer_link: 'https://app.recruitee.com/settings/notifications',
      footer_link_text: 'Notification settings',
      has_avatar: true,
      initials: 'AM',
      avatar_url: 'https://assets.recruitee.com/avatars/123/thumb.png',
    },
    {
      title: 'Alex Morgan mentioned you in an evaluation for Jamie Lee',
      body: 'You were mentioned in an evaluation.',
      footer_p1: 'Replies to this email are not monitored.',
      footer_link: 'https://app.recruitee.com/settings/notifications',
      footer_link_text: 'Notification settings',
      has_avatar: false,
      initials: 'AM',
      avatar_url: null,
    },
  ];
